import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components';
import game from './game';

ReactDOM.render(<App />, document.getElementById('root'));
game();
